import { LOCALES } from '@/constants';
import { getImageUrl } from '@fsd/shared/lib';

type LocaleValue = typeof LOCALES[keyof typeof LOCALES];

export const LANGUAGES_BY_LOCALE: Record<LocaleValue, string> = {
  [LOCALES.EN]: 'English',
  [LOCALES.RU]: 'Русский',
  [LOCALES.ES]: 'Español',
  [LOCALES.FA]: 'فارسی',
  [LOCALES.TR]: 'Türkçe',
  [LOCALES.ID]: 'Bahasa Indonesia',
  [LOCALES.UK]: 'Українська',
  [LOCALES.UZ]: 'O\'zbek',
  [LOCALES.MS]: 'Bahasa Melayu',
  [LOCALES.VI]: 'Tiếng Việt',
  [LOCALES.HI]: 'हिन्दी',
  [LOCALES.NG]: 'Nigerian',
  [LOCALES.TH]: 'ไทย',
  [LOCALES.AZ]: 'Azərbaycan',
  [LOCALES.KK]: 'Қазақ',
};

export interface LanguageList {
  id: LocaleValue;
  label: string;
  languageDescription: string;
  languageLocale: LocaleValue;
  imgSrc: string;
  alt: string;
}

export function createLanguagesList(): LanguageList[] {
  return (Object.values(LOCALES) as LocaleValue[]).map((locale) => ({
    id: locale,
    label: LANGUAGES_BY_LOCALE[locale],
    languageDescription: locale.toUpperCase(), // Гарантированно строка, поэтому `toUpperCase` доступен
    languageLocale: locale,
    imgSrc: getImageUrl(`flags/flag-${locale}.png`),
    alt: `${locale}`,
  }));
}
